import type { ReactNode } from 'react';
import type { CinematicSettings } from '../domain/cinematic-plan';
import type { CinematicEditing } from './use-cinematic-waypoints';

/** Inheritance belongs beside the existing control, without a second attribute editor. */
export function SequenceAttribute({ editing, name, label, children, keyframe }: {
  editing?: CinematicEditing | undefined; name: keyof CinematicSettings; label: string; children: ReactNode;
  keyframe?: { keyed: boolean; toggle: () => void } | undefined;
}) {
  const keyed = keyframe?.keyed ?? editing?.keyed(name) ?? false;
  return <div className="sequence-attribute">
    {children}
    {editing && <div className="sequence-inheritance">
      <span>{keyed ? 'Key at playhead' : 'Changes add a key at playhead'}</span>
      <button type="button" className="sequence-key-toggle studio-key-button" aria-label={`${keyed ? 'Remove' : 'Add'} ${label} key at playhead`}
        aria-pressed={keyed} disabled={editing.readOnly} onClick={() => keyframe ? keyframe.toggle()
          : keyed ? editing.inherit(name) : editing.keyframe(name)}>{keyed ? '◆' : '◇'}</button>
      {keyed && !keyframe && <button type="button" disabled={editing.readOnly} aria-label={`Use earlier ${label}`}
        onClick={() => editing.inherit(name)}>Use earlier</button>}
    </div>}
  </div>;
}
